<template>
  <Modal
    inner-class="overflow-y-scroll rounded"
    size="full"
    @close="closeProductSizeGuide"
  >
    <Skeleton
      v-if="fetching"
      class="absolute inset-0"
      :full-width="true"
      type="custom"
    />
    <div v-else class="px-4 md:px-8">
      <div v-for="item in sizeGuide" :key="item._uid">
        <component :is="item.component" :blok="item" />
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'

const props = defineProps<{ product: Product }>()

const { closeProductSizeGuide, isProductSizeGuideModalOpen } = useUiState()

const { getSizeGuide, sizeGuide, fetching } = useProductSizeGuide(props.product)

watch(
  isProductSizeGuideModalOpen,
  (isOpen) => {
    if (isOpen) {
      getSizeGuide()
    }
  },
  { immediate: true },
)
</script>
